import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fireAdsPurchase } from "@/lib/ads";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function CoachingResult({ outcome }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(outcome === "cancel" ? "cancelled" : "checking");

  useEffect(() => {
    if (outcome === "cancel") return;
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/coaching/checkout/status/${sessionId}`);
        if (data.paid) { setStatus("paid"); fireAdsPurchase({ transactionId: sessionId, value: data.amount }); setTimeout(() => navigate("/coaching"), 1800); return; }
      } catch { /* keep trying */ }
      if (++tries < 12) setTimeout(poll, 1500);
      else setStatus("timeout");
    };
    poll();
  }, [outcome]);

  const map = {
    checking: { icon: Loader2, spin: true, title: "Confirming your subscription…", sub: "One moment." },
    paid: { icon: CheckCircle2, title: "You're in!", sub: "Redirecting to your coaching dashboard…" },
    cancelled: { icon: XCircle, title: "Checkout cancelled", sub: "No charge was made. You can subscribe anytime." },
    timeout: { icon: CheckCircle2, title: "Almost there", sub: "Payment is processing — your access will appear shortly." },
    error: { icon: XCircle, title: "Something went wrong", sub: "Please head back and try again." },
  };
  const s = map[status] || map.checking;
  const Icon = s.icon;

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <Icon className={`h-14 w-14 text-[#FF331F] mx-auto ${s.spin ? "animate-spin" : ""}`} />
        <h1 className="font-display text-3xl uppercase tracking-tight mt-6">{s.title}</h1>
        <p className="text-zinc-400 mt-3">{s.sub}</p>
        <button onClick={() => navigate("/coaching")} className="mt-8 text-sm text-[#FF331F] font-bold uppercase tracking-widest">
          Back to Coaching
        </button>
      </div>
    </div>
  );
}
